import React, { useEffect } from "react";
import beautyOfJseon from "../../assets/images/website-images/beauty-of-jseon.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TabProduct from "./TabProduct";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import {
  convertToKebabCase,
  getGridSizeData,
  parseQueryParams,
} from "src/helpers/helperFunctions";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";
import { useNavigate } from "react-router-dom";

const ConsultADoctorHoveredTab = ({
  id,
  style,
  onClose,
  allSpecialists,
  specialistLoader,
  setSpecialistLoader,
  setAllSpecialists,
}: {
  id: string;
  style: React.CSSProperties;
  onClose: () => void;
  allSpecialists: any[];
  specialistLoader: boolean;
  setSpecialistLoader: (specialistLoader: boolean) => void;
  setAllSpecialists: (allSpecialists: any[]) => void;
}) => {
  const navigate = useNavigate();
  const getAllSpecialists = async () => {
    setSpecialistLoader(true);
    const { res, err } = await httpRequest<
      {
        _id: string;
        name: string;
        SpecailImage: string;
      }[]
    >({
      path: "/provider/special/get",
    });
    if (res) {
      setAllSpecialists(
        res.map((item) => ({
          id: item._id,
          name: item.name,
          image:  item.SpecailImage,
        }))
      );
    } else {
      toast(err, { type: "error" });
    }
    setSpecialistLoader(false);
  };

  useEffect(() => {
    getAllSpecialists();
  }, []);

  const { gridCols, totalDataLength } = getGridSizeData({
    rows: 3,
    extraLarge: 5,
    large: 5,
    medium: 4,
    small: 2,
  });

  return (
    <div id={id} className="relative p-1 pt-0 h-fit min-h-[250px] xl:min-h-[300px] w-full">
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 rounded-br-md rounded-bl-md bg-white shadow relative"
      >
        <div className="flex justify-between items-end">
          <div>
            <h2 className="font-Lexend-SemiBold font-size-35px theme-color-green">
              Consult a Doctor
            </h2>
            <p className="font-size-18px font-Poppins-Regular under-dropdown-text">
              Explore all the Doctor for Consultation
            </p>
          </div>
          <div
            className="font-size-16px font-Poppins-SemiBold theme-color-green-3f underline cursor-pointer"
            onClick={() => {
              onClose();
              navigate("/all-specializations");
            }}
          >
            View All
          </div>
        </div>
        <div
          className={`grid grid-cols-2 md:grid-cols-${gridCols} gap-2 xl:gap-3 2xl:gap-4 mt-3 xl:mt-4`}
        >
          {allSpecialists.slice(0, totalDataLength).map((item, index) => (
            <TabProduct
              key={"Consult A Doctor" + index}
              data={item}
              id={`counsult-doctor-${index}`}
              onClick={() => {
                onClose();
                let q = {
                  [QueryPath.specialization]: item.id,
                  [QueryPath.specializationName]: item.name,
                }
                navigate(
                  `/consult-a-doctor?${parseQueryParams(q)}`,
                );
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConsultADoctorHoveredTab;
